import styles from "./404.module.css";

const Error404 = () => {
  return (
    <div className={styles.Message}>
      <img src="/assets/oops.svg" />
      <p>Something went wrong</p>
      <span>
        Sorry we could not process your request. Please try again after
        sometime.
      </span>
    </div>
  );
};

export default Error404;
